import getApiClient from '@/plugins/api-client'

export default {
    sendInvites: function() {
        const self = this,
            api = getApiClient(self.$store),
            eventId = self.$route.params.id,
            payload = self.mountInvitesPayload()


        payload.billingTime = self.billingTime
        self.errors.billingTime = null
        self.$store.commit('setProfileSearchFilters', {})

        api.put(`events/${eventId}/checkout`, payload)
            .then(() => {
                self.$store.commit('setCreatingEvent', null)
                self.showCompletedJobDialog = true
            })
            .catch(error => {
                let violations = error.response.data?.violations
                if (violations) {
                    violations.forEach(violation => {
                        self.errors[violation.propertyPath] = violation.message
                        if (violation.propertyPath === 'event') {
                            self.showErrorDialog = true
                        }
                    })
                }
            })
    },

    mountInvitesPayload: function() {
        const self = this,
          existingJobs = self.$store.state.profileFinder?.event?.jobs

        let invites = {
            jobs: [],
            profilesFoundBySymplaEvents: {},
        }

        self.profileSearches.forEach(search => {
            search.profiles.forEach(profile => {
                let job = {
                    workProfile: `/work_profiles/${profile.id}`,
                    foodIncluded: self.jobDetails.foodIncluded,
                    uniformIncluded: self.jobDetails.uniformIncluded,
                    socialClothing: self.jobDetails.socialClothing,
                    uniformDetails: self.jobDetails.uniformDetails,
                    type: search.type,
                    fee: search.fee,
                    profileSearch: typeof search.id === 'number' ? `/profile_searches/${search.id}` : search.id
                }

                let jobExists = existingJobs.filter(existingJob => {
                    return existingJob?.workProfile?.id === profile.id
                })[0]

                if (jobExists) {
                    job['@id'] = jobExists['@id']
                    job.id = jobExists.id
                }

                invites.jobs.push(job)
            })
        })

        const profilesFoundBySymplaEvents = {}
        const storedProfilesFoundBySymplaEvents = self.$store.state.profilesFoundBySymplaEvents

        for (let profile in storedProfilesFoundBySymplaEvents) {
            if (
                invites.jobs.filter(job => {
                    return job.workProfile === `/work_profiles/${profile}`
                }).length > 0 &&
                storedProfilesFoundBySymplaEvents[profile].length
            ) {
                profilesFoundBySymplaEvents[profile] = storedProfilesFoundBySymplaEvents[profile].map(id => `/sympla_events/${id}`)
            }
        }

        invites.symplaEventsUsed = profilesFoundBySymplaEvents

        return invites
    },
    applyTaxes(value) {
        return (value += (value * .20)) + (value * .19)
    },
    getSymplaEventTax(eventId, baseAmount) {
        const event = this.$store.state.symplaEvents.filter(symplaEvent => {
            return symplaEvent.id === eventId
        })[0]

        let amount = 0

        if (!event.tax) {
            return 0
        }

        const tax  = baseAmount * (event.tax / 100)
        amount += tax

        return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(amount)
    },
    getSymplaEventBadge(eventId) {
        const event = this.$store.state.symplaEvents.filter(symplaEvent => {
            return symplaEvent.id === eventId
        })[0]

        return event?.badge
    },
    profileHasTaxes(profileId) {
        const symplaEvents = this.$store.state.profilesFoundBySymplaEvents[profileId]
        const profileWasFoundBySymplaEvent = symplaEvents?.length > 0
        let eventsWithTaxes = 0

        if (profileWasFoundBySymplaEvent) {
            for (let eventId in symplaEvents) {
                let event = this.$store.state.symplaEvents.filter(symplaEvent => {
                    return symplaEvent.id === symplaEvents[eventId]
                })

                if (event[0] && event[0].tax) {
                    eventsWithTaxes++
                }
            }
        }

        return profileWasFoundBySymplaEvent && eventsWithTaxes > 0
    }
}
